import { Component } from 'react';
import Util from '../../lib/util.js';
import User from 'services/user2';
import { Msg } from 'react-weui';
import * as dd from 'dingtalk-jsapi'; // 此方式为整体加载，也可按需进行加载

/**
 * 钉钉登录跳转页
 *
 * https://open.dingtalk.com/document/orgapp/sso-overview
 *
 *
 * corpId	企业id,由页面参数传入
 *
 */
class DingTalk extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMsg: null,
      code: null,
      corpId: null,
      last: null,
    };
    this.dialogMsg = '';
  }
  /**
   *
   * https://app116127.eapps.dingtalkcloud.com/mp/dingTalk?corpId=$CORPID$&redirect_path=#REDIRECT_PATH#

  REDIRECT_PATH: '%2Fmp%2Fsale%2Fcustomer%2Forder%2Flist'
  /mp/sale/customer/order/list
   */
  init() {
    let { corpId, redirect_path } = Util.getParamObj(window.location.search);

    let setState = state => {
      this.setState(state);
    };

    let redirect = () => {
      if (redirect_path) {
        // redirect_path = '%2Fmp%2Fsale%2Fcustomer%2Forder%2Flist%3FcompanyCode%3D123456';
        let redirectPath = decodeURIComponent(redirect_path);
        let [path, search] = redirectPath.split('?');
        let companyCode = '';
        if (search) {
          let params = new URLSearchParams(search);
          companyCode = params.get('companyCode');
        }
        // this.sendEvent({
        //   redirectPath: redirectPath,
        //   path: path,
        //   companyCode: companyCode,
        // });
        this.props.history.push(
          '/mp/index?path=' + path + '&companyCode=' + companyCode
        );
      } else {
        this.props.history.push('/mp/index');
      }
    };
    //setState({ corpId: corpId });
    dd.ready(function () {
      dd.runtime.permission.requestAuthCode({
        corpId, // 企业id
        onSuccess: function (info) {
          let code = info.code; // 通过该免登授权码可以获取用户身份
          //setState({ code: code });
          User.dingTalkInit(corpId, code, null).then(response => {
            if (response.success) {
              redirect();
            } else {
              setState({ errorMsg: response.errorMsg });
            }
          });
        },
      });
    });
  }

  sendEvent(params = {}) {
    let search = window.location.search;
    let { corpId, redirect_path } = Util.getParamObj(window.location.search);
    let postbody = {
      action: 'dingtalk',
      search: search,
      corpId: corpId,
      ...params,
      redirect_path: redirect_path,
    };
    // 发送异步和非阻塞请求，且不需要响应
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/event', JSON.stringify(postbody));
    }
  }

  componentDidMount() {
    this.init();
  }

  render() {
    let errorMsg = this.state.errorMsg;
    if (errorMsg) {
      return <Msg type="warn" title={errorMsg} />;
    }
    return '';
    // return (
    //   <div>
    //     <p>corpId: {this.state.corpId}</p>
    //     <p>code: {this.state.code}</p>
    //     <p>last: {this.state.last}</p>
    //   </div>
    // );
  }
}

export default DingTalk;
